import { useEffect } from 'react';

export function useWakeLock() {
    useEffect(() => {
        let wakeLock = null;

        async function enableWakeLock() {
            try {
                wakeLock = await navigator.wakeLock.request('screen');
                console.log('Screen Wake Lock is active');

                // Re-request the wake lock if the page becomes visible again
                document.addEventListener('visibilitychange', async () => {
                    if (wakeLock !== null && document.visibilityState === 'visible') {
                        wakeLock = await navigator.wakeLock.request('screen');
                    }
                });
            } catch (err) {
                console.error(`Failed to enable wake lock: ${err.name}, ${err.message}`);
            }
        }

        // Enable wake lock on mount
        enableWakeLock();

        // Clean up and release wake lock when component unmounts
        return () => {
            if (wakeLock !== null) {
                wakeLock.release().then(() => {
                    wakeLock = null;
                    console.log('Screen Wake Lock was released');
                });
            }
        };
    }, []);

    // This hook does not need to return anything
}
